import { render, staticRenderFns } from "./multiPiecesEdit.vue?vue&type=template&id=2703ca27&scoped=true&"
import script from "./multiPiecesEdit.vue?vue&type=script&lang=js&"
export * from "./multiPiecesEdit.vue?vue&type=script&lang=js&"
import style0 from "./multiPiecesEdit.vue?vue&type=style&index=0&id=2703ca27&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703ca27",
  null
  
)

export default component.exports